<template>
  <div>
    <!-- <div @click="downloadFileDialog = true" v-if="btn !== false">
      <slot />
    </div> -->
    <v-dialog
      persistent
      width="900"
      v-model="downloadFileDialog"
      transition="dialog-bottom-transition"
      @keydown.esc="closeFileDialog"
    >
      <v-card>
        <v-toolbar dark color="primary" max-height="60">
          <h3>{{ $i18n.t(label) }}</h3>
          <v-spacer />
          <v-btn icon dark @click="closeFileDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="8" md="10" lg="10">
              <z-template-select
                v-model="template_id"
                :kind="kind"
                :forUpload="forUpload"
              ></z-template-select>
              <v-row style="padding: 10px 10px" v-if="forUpload">
                <v-file-input
                  chips
                  label="Attachment"
                  @change="handleFileUpload()"
                  v-model="file"
                ></v-file-input>
              </v-row>
              <span v-if="forUpload && template_id != null">
                Upload Detail in xlsx file. A Sample xlsx can be found <a :href="'/api/template/' + template_id + '/sample'" style="cursor:pointer;">here</a>
              </span>
            </v-col>
            <v-col cols="12" sm="4" md="2" lg="1"
              ><v-btn
                color="green"
                class="mr-0"
                v-on:click="downloadFile()"
                :loading="dw_loading"
                v-if="!forUpload"
              >
                <h3>{{ $i18n.t("Download") }}</h3>
              </v-btn>
              <v-btn
                color="green"
                class="mr-0"
                v-on:click="uploadFile()"
                :loading="dw_loading"
                v-if="forUpload"
              >
                <h3>{{ $i18n.t("Upload") }}</h3>
              </v-btn></v-col
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doGetWithDownload, doPostFormWithDownload } from "@/store/common/module/apis";

@Component({
  name: "DownloadFile",
  components: {},
  props: {
    showDialog: {
      default: false,
    },
    requestURL: {
      default: null,
    },
    kind: {
      default: false,
    },
    forUpload: {
      default: false,
    },
    label: {
      default: "Download File",
    },
  },
})
export default class DownloadFile extends Vue {
  downloadFileDialog = false;
  file_download = null;
  dw_loading = null;
  template_id = null;
  file = null;

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.downloadFileDialog = val;
    if (!val) this.$emit("closeDialog", true);
  }

  closeFileDialog(reload) {
    this.$emit("closeDialog", true);
    this.downloadFileDialog = false;
  }

  async downloadFile() {
    if (this.requestURL) {
      try {
        common.setLoading(true);
        this.dw_loading = true;
        await doGetWithDownload(
          this.requestURL + "&template_id=" + this.template_id
        );
        this.dw_loading = null;
        this.closeFileDialog(false);
      } catch (e) {
        this.dw_loading = null;
        this.closeFileDialog(false);
        common.setError(e.message);
        common.setLoading(false);
      }
    }
  }

  handleFileUpload(files) {
    if (files) {
      this.file = files[0];
    }
  }

  async uploadFile() {
    if (this.requestURL) {
      try {
        common.setLoading(true);

        const formData = new FormData();
        if (this.file) {
          formData.append("file", this.file);
        } else {
          common.setError("File note provided to upload");
          return;
        }
        this.dw_loading = true;
        await doPostFormWithDownload(this.requestURL + "&template_id=" + this.template_id, formData);
        this.dw_loading = null;
        this.closeFileDialog(true);
      } catch (e) {
        this.dw_loading = null;
        this.closeFileDialog(true);
        common.setError(e.message);
        common.setLoading(false);
      }
    }
  }
}
</script>
